import { Login } from '../entities/login-entity';
import { LoginRepository } from '../repositories/login-repository';

interface LoginUsecase {
  Login(email: string, password: string): Promise<Login>;
}

export class LoginUsecaseImpl implements LoginUsecase {
  LoginRepository: LoginRepository;

  constructor(lr: LoginRepository) {
    this.LoginRepository = lr;
  }

  async Login(email: string, password: string): Promise<Login> {
    return this.LoginRepository.Login(email, password);
  }
}
